export * from "./mapHeader/MapHeader.resolver"
export * from "./collection/Collection.resolver"
export * from "./listOfPois/ListOfPois.resolver"
export * from "./timeline/Timeline.resolver"
export * from "./callToAction/CallToAction.resolver"
export * from "./columns/Columns.resolver"
export * from "./content/Content.resolver"
export * from "./contentWithImage/ContentWithImage.resolver"
export * from "./downloads/Downloads.resolver"
export * from "./gallery/Gallery.resolver"
export * from "./hero/Hero.resolver"
export * from "./image/Image.resolver"
export * from "./imagesLinks/ImagesLinks.resolver"
export * from "./logoGrid/LogoGrid.resolver"
export * from "./pageHeader/PageHeader.resolver"
export * from "./teasers/TeasersCustom.resolver"
export * from "./teasers/TeasersLatest.resolver"
export * from "./teasers/TeasersManual.resolver"
export * from "./video/Video.resolver"
export * from "./form/Form.resolver"
